import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import IconTextField from "../components/IconTextField";
import { EmailOutlined } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import loginbg from "../assets/login-image.png";
import { useNavigate, useParams } from "react-router-dom";
import appTheme from "../themes/theme";
import { confirmPasswordUpdate } from "../services/jbwAuthServices";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, LinearProgress, List, ListItem, ListItemText } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { decryptData } from "../utils/encryption";
const ResetPassword = () => {
  const { id } = useParams();
  const Navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [serviceErr, setServiceErr] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState("");
  const [pwdChangeErr, setPwdChangeErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [securityCode, setSecurityCode] = useState("");
  const [codeErr, setCodeErr] = useState("");

  useEffect(() => {
    if (id) {
        console.log("url id :",id.split('&code='))
  const secode = id.split('&code=')[1];
      const decoded = decodeURIComponent(id.split('&code=')[0]);
      const dyData = decryptData(decoded);
      console.log("dycrepeted Data :", dyData);
      if (dyData && dyData.email) {
        setEmail(dyData.email);
        setSecurityCode(secode);
      }
    }
  }, [id]);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const formInputChange = (formField, value) => {
    if (formField === "email") {
      setEmail(value);
    }

    if (formField === "securityCode") {
      setSecurityCode(value);
    }
    if (formField === "newPassword") {
      setPassword(value);
    }
    if (formField === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const validation = () => {
    return new Promise((resolve, reject) => {
      if (password === "" && confirmPassword === "" && securityCode === "") {
        setPasswordErr("New Password required");
        setConfirmPasswordErr("Confirm Password required");
        setCodeErr("Security Code required");
        resolve({
          password: "New Password required",
          confirmPassword: "Confirm Password required",
          securityCode: "Security Code required",
        });
      } else if (securityCode === "") {
        setCodeErr("Security Code required");
        resolve({
          securityCode: "Security Code Required",
          password: "",
          confirmPassword: "",
        });
      } else if (password === "") {
        setPasswordErr("New Password required");
        resolve({
          password: "New Password required",
          confirmPassword: "",
          securityCode: "",
        });
      } else if (!validatePassword(password)) {
        setPasswordErr("The entered password doesn't meet the required password policy listed below");
        resolve({
          password: "The entered password doesn't meet the required password policy listed below",
          confirmPassword: "",
          securityCode: "",
        });
      } else if (confirmPassword === "") {
        setConfirmPasswordErr("Confirm Password required");
        resolve({
          password: "",
          securityCode: "",
          confirmPassword: "Confirm Password required",
        });
      } else if (!validatePassword(confirmPassword)) {
        setConfirmPasswordErr("Entered Confirm Password in not matching");
        resolve({
          password: "",
          securityCode: "",
          confirmPassword: "Entered Confirm Password in not matching",
        });
      } else if (confirmPassword !== password) {
        setConfirmPasswordErr("Confirm Password and New Password must be same");
        resolve({
          password: "",
          securityCode: "",
          confirmPassword: "Confirm Password and New Password must be same",
        });
      } else {
        resolve({ password: "", confirmPassword: "", securityCode: "" });
      }
      reject("");
    });
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!\-@#%&\/\\,><':;|_~`+=])[A-Za-z\d\^$*.\[\]{}()?"!\-@#%&\/\\,><':;|_~`+=]{8,}$/;
    return regex.test(password);
  };

  const errorMessages = {
    CodeMismatchException: "Wrong security code.",
    ExpiredCodeException: "Invalid code provided, please request a code again.",
    LimitExceededException:
      "Attempt limit exceeded, please try after some time.",
    UserNotFoundException: "User does not exist."
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setIsFormSubmitted(true);
    setPwdChangeErr("");
    setPasswordErr("");
    setConfirmPasswordErr("");
    setCodeErr("");
    validation()
      .then(
        (res) => {
          if (
            res.password === "" &&
            res.confirmPassword === "" &&
            res.securityCode === ""
          ) {
            confirmPasswordUpdate(email, securityCode, password)
              .then(
                (res) => {
                  console.log(
                    "Password confirmed successfully:" + JSON.stringify(res)
                  );
                  if (res === "SUCCESS") {
                    setIsFormSubmitted(false);
                    setSecurityCode("");
                    setEmail("");

                    setConfirmPassword("");
                    setPassword("");
                    handleBackToLoging();
                  }
                },
                (err) => {
                  console.error("Error confirming password:", err);
                  const errorMessage =
                    errorMessages[err.code] || "An error occurred.";
                  console.log(errorMessage);
                  setCodeErr(errorMessage);

                  setIsFormSubmitted(false);
                }
              )
              .catch((err) => {
                console.error("Error", err);
                setPwdChangeErr("Internal Server error");
                setIsFormSubmitted(false);
              });
          } else {
            setIsFormSubmitted(false);
          }
        },
        (err) => {
          console.log("Error validating the password :", err);
          setIsFormSubmitted(false);
        }
      )
      .catch((err) => {
        console.log(err);
        setIsFormSubmitted(false);
      });
  };

  const handleBackToLoging = () => {
    Navigate("/");
  };

  return (
    <ThemeProvider theme={appTheme}>
      <Grid container sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${loginbg})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            m="auto"
            sx={{
              width: 300,
              my: 8,
              mx: 4,
              ml: 20,
              mt: 30,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5">
              Hello!
            </Typography>
            <Typography component="div" variant="h6" sx={{ fontSize: "14px" }}>
              Please enter the security code sent to your email
            </Typography>
            <Box component="form" noValidate>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="stretch"
              >
                <Grid item xs={12} sm={6} md={6}>
                  <IconTextField
                    iconStart={
                      <EmailOutlined sx={{ color: "#bdbdbd", fontSize: 20 }} />
                    }
                    margin="normal"
                    fullWidth
                    id="email"
                    placeholder="Email Address"
                    name="email"
                    autoComplete="email"
                    value={email}
                    //onChange={(e) => formInputChange("email", e.target.value)}
                    error={emailErr ? true : false}
                    helperText={emailErr}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <IconTextField
                    iconStart={
                      <VpnKeyIcon sx={{ color: "#bdbdbd", fontSize: 20 }} />
                    }
                    margin="normal"
                    required
                    fullWidth
                    id="securityCode"
                    placeholder="Security Code"
                    name="securityCode"
                    value={securityCode}
                    onChange={(e) =>
                      formInputChange("securityCode", e.target.value)
                    }
                    error={codeErr ? true : false}
                    helperText={codeErr}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <IconTextField
                    iconStart={
                      <LockOutlinedIcon
                        sx={{ color: "#bdbdbd", fontSize: 20 }}
                      />
                    }
                    iconEnd={
                      <IconButton
                        aria-label={
                          showPassword
                            ? "hide the password"
                            : "display the password"
                        }
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    }
                    margin="normal"
                    id="newPassword"
                    label="New Password"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) =>
                      formInputChange("newPassword", e.target.value)
                    }
                    error={passwordErr ? true : false}
                    helperText={passwordErr}
                    icon={<LockOutlinedIcon />}
                    size="small"
                    disabled={isFormSubmitted ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <IconTextField
                    iconStart={
                      <LockOutlinedIcon
                        sx={{ color: "#bdbdbd", fontSize: 20 }}
                      />
                    }
                    margin="normal"
                    id="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    value={confirmPassword}
                    onChange={(e) =>
                      formInputChange("confirmPassword", e.target.value)
                    }
                    error={confirmPasswordErr ? true : false}
                    helperText={confirmPasswordErr}
                    size="small"
                    disabled={isFormSubmitted ? true : false}
                  />
                </Grid>
                {confirmPassword.length > 0 && (
                  <Grid item xs={12} sm={6} md={6}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
                      {password === confirmPassword ? (
                        <CheckCircleIcon sx={{ fontSize: 14, color: "#4caf50" }} />
                      ) : (
                        <CancelIcon sx={{ fontSize: 14, color: "#f44336" }} />
                      )}
                      <Typography
                        variant="body"
                        sx={{ fontSize: "12px", color: password === confirmPassword ? "#4caf50" : "#f44336" }}
                      >
                        {password === confirmPassword ? "Passwords match" : "Passwords do not match"}
                      </Typography>
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={6}>
                  <Typography
                    variant="body"
                    sx={{ color: "#f44336", fontSize: "10px" }}
                  >
                    {pwdChangeErr}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 2,
                      borderRadius: "50px",
                    }}
                    onClick={handleChangePassword}
                    size="small"
                    disabled={isFormSubmitted ? true : false}
                  >
                    Reset Password
                  </Button>
                  <Button
                    type="submit"
                    fullWidth
                    variant="text"
                    sx={{
                      borderRadius: "50px",
                    }}
                    onClick={handleBackToLoging}
                    startIcon={<ArrowBackIcon />}
                    size="small"
                    disabled={!isFormSubmitted ? false : true}
                  >
                    Back to Login Page
                  </Button>
                  <Typography
                    variant="body"
                    sx={{ color: "#f44336", fontSize: "10px" }}
                  >
                    {serviceErr}
                  </Typography>
                </Grid>
                {password.length > 0 && (
                  <Grid item xs={12} sm={6} md={6}>
                    {(() => {
                      const rules = [
                        { label: "Minimum 8 characters", pass: password.length >= 8 },
                        { label: "At least 1 number", pass: /\d/.test(password) },
                        { label: "At least 1 special character (@$!%*?&)", pass: /[@$!%*?&]/.test(password) },
                        { label: "At least 1 uppercase letter", pass: /[A-Z]/.test(password) },
                        { label: "At least 1 lowercase letter", pass: /[a-z]/.test(password) },
                      ];
                      const passCount = rules.filter((r) => r.pass).length;
                      const strengthMap = [
                        { label: "Weak", color: "#f44336", value: 20 },
                        { label: "Weak", color: "#f44336", value: 20 },
                        { label: "Fair", color: "#ff9800", value: 40 },
                        { label: "Fair", color: "#ff9800", value: 60 },
                        { label: "Good", color: "#FFB200", value: 80 },
                        { label: "Strong", color: "#4caf50", value: 100 },
                      ];
                      const strength = strengthMap[passCount];
                      return (
                        <>
                          <Box sx={{ mt: 1, mb: 1 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                              <Typography variant="body" sx={{ fontSize: "11px", color: "#888" }}>
                                Password strength
                              </Typography>
                              <Typography variant="body" sx={{ fontSize: "11px", fontWeight: "bold", color: strength.color }}>
                                {strength.label}
                              </Typography>
                            </Box>
                            <LinearProgress
                              variant="determinate"
                              value={strength.value}
                              sx={{
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: "#e0e0e0",
                                "& .MuiLinearProgress-bar": { backgroundColor: strength.color },
                              }}
                            />
                          </Box>
                          <List dense disablePadding>
                            {rules.map((rule) => (
                              <ListItem key={rule.label} disableGutters sx={{ py: 0 }}>
                                <ListItemText
                                  primary={
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                      {rule.pass ? (
                                        <CheckCircleIcon sx={{ fontSize: 14, color: "#4caf50" }} />
                                      ) : (
                                        <CancelIcon sx={{ fontSize: 14, color: "#f44336" }} />
                                      )}
                                      <Typography
                                        variant="body"
                                        sx={{ fontSize: "12px", color: rule.pass ? "#4caf50" : "#f44336" }}
                                      >
                                        {rule.label}
                                      </Typography>
                                    </Box>
                                  }
                                />
                              </ListItem>
                            ))}
                          </List>
                        </>
                      );
                    })()}
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default ResetPassword;
